<template><div :class="{ '_selected': isBooked()}">

    <slot name="default"  :detail_click="detail_click" @click.stop.prevent="detail_click" >RoomSelector</slot>
    
    <RoomModal :Cabin="props.Cabin" :CabinSet="props.CabinSet" 
        :modalShown="isModalShown" @input="set_isModalShown" />

</div></template>


<script setup>
import {ref, unref, computed, onMounted, watch, nextTick} from 'vue'
import useCruiseStore from '@/cstore.js'
import useCabinsStore from '@/bookCabins.js'
import Mest from '@/comp/CruiseHead/Mest.vue'
import { numWord } from '@/util.js'
import RoomModal from './RoomModal.vue'

const cstore = useCruiseStore()
const bookCabins = useCabinsStore()

const props = defineProps({
    Cabin : Object,
    CabinSet : Object,
})

const isModalShown = ref(false)
const set_isModalShown = nov => isModalShown.value = nov
const detail_click = () => {
    isModalShown.value = true
}

const isBooked = () => bookCabins.isBooked( props.Cabin.id )


</script>
